import React from "react";
import {Row, Col, List, Card} from "antd";
import {
    ArticleH2,
    ArticleH3,
    ArticleHeader,
    ArticleParagraph,
    ArticleText,
    NumberedList
} from "../../../../components/DesignSystem/Articles/Articles";
import {Spacer} from "../../../../components/DesignSystem/Spacer/Spacer";

export const BasicViewPage = ({type}) => {

    const data = [
        {
            title: 'Interactive data grid',
            description: 'View and explore your data in a user-friendly grid format',
        },
        {
            title: 'Advanced filtering',
            description: 'Filter data by any column or value to focus on specific insights',
        },
        {
            title: 'Sort Functionality',
            description: 'Arrange filtered data by any column in ascending or descending order'
        },
        {
            title: 'Export Filtered Data',
            description: 'Save your filtered results in various formats',
        }
    ];

    return <Row align={"center"} style={{backgroundColor: 'white'}} gutter={[16, 16]}>
        <Col sm={16}>
            <ArticleHeader>{type} Viewer</ArticleHeader>
            <ArticleParagraph>Open and analyze {type} files with our AI-powered viewer. Ask questions in plain English and get instant insights
                from your data.</ArticleParagraph>
        </Col>
        <Col sm={16}>
            <ArticleH2>{type} Viewer Features</ArticleH2>
            <Spacer size={"large"}/>
            <List
                grid={{gutter: 16, column: 2}}
                dataSource={data}
                renderItem={(item) => (
                    <List.Item>
                        <Card>
                            <h5>{item.title}</h5>
                            <ArticleText>{item.description}</ArticleText>
                        </Card>
                    </List.Item>
                )}
            />

        </Col>
        <Col sm={16}>
            <ArticleH3>
                How to analyze {type} files with AI
            </ArticleH3>
            <NumberedList>
                <li>Upload your {type} file using the upload button</li>
                <li>Let our AI analyze your data structure and patterns</li>
                <li>Ask questions about your data in plain English</li>
                <li>Get instant insights and visualizations</li>
                <li>Filter and sort data as needed</li>
                <li>Perform advanced analysis with AI assistance</li>
                <li>Export or share your findings</li>
            </NumberedList>
        </Col>
    </Row>
}